<template>
  <p class="text-center text-muted" v-if="!loading && totalData > 0">
    Mostrando {{ fromData }} al {{ toData }} de {{ totalData }} registros.
  </p>
</template>
<script>
export default {
  name: "TableRecords",
  props: {
    loading: { type: Boolean, required: true },
    page: { required: true },
    from: { required: true },
    to: { required: true },
    total: { required: true },
  },
  computed: {
    fromData() {
      return this.from ? this.from : 0;
    },
    toData() {
      return this.to ? this.to : 0;
    },
    totalData() {
      return this.total ? this.total : 0;
    },
  },
};
</script>
